import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Button from "common/components/Button/Button"
import { useTranslation } from "react-i18next"

const DropzoneRegular = ({
  acceptLabel,
  butonLabel,
  hideAcceptedFilesMsg,
  getInputProps,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <>
      <FontAwesomeIcon
        icon={["fal", "cloud-upload"]}
        size='4x'
        className='icon-cloud'
      />

      <p className='text-center'>
        {t("importar.dropDown.textMsgFour")}
        <br />
        {t("importar.dropDown.textMsgTwo")}
        <span className='upload-link'>
          {t("importar.dropDown.textMsgThree")}
        </span>
      </p>

      <div>
        <Button className='!tw-bg-primary tw-cursor-pointer'>
          {butonLabel}
        </Button>
      </div>

      {!hideAcceptedFilesMsg && (
        <p className='mt-4'>
          ({t("importar.dropDown.textmsgFive")}
          {acceptLabel})
        </p>
      )}

      <input {...getInputProps()} />
    </>
  )
}

export default DropzoneRegular
